// extracted by mini-css-extract-plugin
export default {"loadingContainer":"LoadingScreen_loadingContainer__s+ZCz"};